'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.copyLogData = copyLogData;
exports.generateObjectWithPascalCaseKeys = generateObjectWithPascalCaseKeys;
exports.serializeQueryString = serializeQueryString;
exports.getReferrerRoot = getReferrerRoot;
function toPascalCase(camelCased) {
  if (!camelCased) {
    return camelCased;
  }

  return camelCased.charAt(0).toUpperCase() + camelCased.slice(1);
}

function copyLogData() {
  var ownLogData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var parentLogData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var defaultLogData = arguments[2];

  return _extends({}, ownLogData, defaultLogData, parentLogData);
}

function generateObjectWithPascalCaseKeys(object) {
  var pascalCaseObject = {};
  Object.keys(object).forEach(function (key) {
    pascalCaseObject[toPascalCase(key)] = object[key];
  });

  return pascalCaseObject;
}

function serializeQueryString(params) {
  return '?' + Object.keys(params).map(function (key) {
    var hasValue = params[key] !== undefined && params[key] !== null;
    return hasValue ? encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) : undefined;
  }).filter(function (param) {
    return param !== undefined;
  }).join('&');
}

function getReferrerRoot(referrerUrl) {
  if (!referrerUrl) return '';
  var hostname = '';

  try {
    var a = document.createElement('a');
    a.href = referrerUrl;
    hostname = a.hostname;
  } catch (err) {
    return '';
  }

  var parts = hostname.split('.');

  // Note: .co.uk and .k12.$$.us are by far our most common compound TLDs
  if (hostname.match(/.co.uk$/)) {
    return parts.slice(parts.length - 3).join('.');
  } else if (hostname.match(/.k12.*.us$/)) {
    return parts.slice(parts.length - 4).join('.');
  }

  return parts.slice(parts.length - 2).join('.');
}